export const formatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	maximumFractionDigits: 0,
	minimumFractionDigits: 0
});

export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

export const getModelKey = (year, make, model) =>
	`${year}-${make.toLowerCase()}-${model.toLowerCase()}`;

const deduplicateUrlParams = (url) => {
	const urlParts = url.split('?');
	if (urlParts.length === 1) {
		return url;
	}
	const baseUrl = urlParts[0];
	const queryParams = urlParts[1].split('&');
	const seenParams = new Set();
	const deduplicatedParams = [];
	queryParams.forEach((param) => {
		const [key, value] = param.split('=');
		if (!seenParams.has(key)) {
			seenParams.add(key);
			deduplicatedParams.push(`${key}=${value}`);
		}
	});
	return `${baseUrl}?${deduplicatedParams.join('&')}`;
};

export const getResizedImageUrl = (imageUrl, width) => {
	// This was because passing the image in sometimes has double params
	// TODO: figure out why this is happening ^^^
	// Note on double params:
	// it looks like this method is being called twice for every image
	// which means there is a double render going on in color screen.
	// probably due to a useEffect not having correct dependencies
	const resizeParams = `w=${width}&impolicy=resize`;
	const [imagePath, imageParams] = imageUrl.split('?');
	const originalParams = imageParams ? `${imageParams}&` : '';

	return deduplicateUrlParams(
		`${imagePath.replace(
			'origin-images.qa.',
			'images.'
		)}?${originalParams}${resizeParams}`
	);
};

// A client had a 3rd party script overriding the native URLSearchParams().
// This broke react-router's useSearchParams as well as any usages of the native function.
export const getUrlParams = (searchParams) => {
	const params = {};
	let queryString = searchParams;
	if (queryString) {
		queryString = queryString.substring(1);
		const paramArray = queryString.split('&');
		paramArray.forEach((paramString) => {
			const param = paramString.split('=');
			const key = decodeURIComponent(param[0]);
			const value = decodeURIComponent(param[1]);
			params[key] = value;
		});
	}
	return params;
};
